module.exports = __webpack_public_path__ + "static/media/like-filled.30ecb8b1.svg";